import { RunStateTransition } from "types/generated";

import FinishedEntry from "../entries/FinishedEntry";
import { getRunStateTransitionId } from "./getRunStateTransitionId";
import { RunEntryContext } from "../types";

export const createFinishedEntry = (
  { timestamp, stateVersion }: RunStateTransition,
  { stackId, runId, canPromote }: RunEntryContext
) => {
  return (
    <FinishedEntry
      key={getRunStateTransitionId(timestamp, stateVersion)}
      timestamp={timestamp}
      stackId={stackId}
      runId={runId}
      canPromote={canPromote}
    />
  );
};
